import { useState } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { Button } from '../ui/button';
import { Copy, Check, AlertTriangle, Wallet, ChevronDown } from 'lucide-react';
import { toast } from 'sonner';
import { fmtEur } from './investmentShared';
import { ConfirmPaymentForm } from './ConfirmPaymentForm';

export const InvestmentPaymentWallet = ({ request, onChanged }) => {
    const [open, setOpen] = useState(request.payment?.status !== 'verified');
    const [copied, setCopied] = useState(false);
    const w = request.payment_wallet;
    if (!w) return null;

    const copy = async () => {
        try {
            await navigator.clipboard.writeText(w.address);
            setCopied(true);
            toast.success('Dirección copiada');
            setTimeout(() => setCopied(false), 2000);
        } catch {
            toast.error('No se pudo copiar');
        }
    };

    return (
        <div className="mt-3 rounded-xl border border-amber-500/30 bg-[#0b0b0d] overflow-hidden" data-testid={`investment-wallet-${request.id}`}>
            <button type="button" onClick={() => setOpen(!open)} className="w-full flex items-center gap-2 px-3.5 py-2.5 text-left" data-testid={`investment-wallet-toggle-${request.id}`} aria-expanded={open}>
                <Wallet className="w-4 h-4 text-amber-300" />
                <span className="text-[11px] uppercase tracking-wider font-bold text-amber-200 flex-1">Wallet de pago · {w.name} · {w.network}</span>
                <ChevronDown className={`w-4 h-4 text-slate-400 transition-transform ${open ? 'rotate-180' : ''}`} />
            </button>
            {open && (
                <div className="px-3.5 pb-4 flex flex-col sm:flex-row items-center gap-4">
                    <div className="p-2 bg-white rounded-xl flex-shrink-0"><QRCodeSVG value={w.address} size={128} level="H" data-testid={`investment-wallet-qr-${request.id}`} /></div>
                    <div className="flex-1 min-w-0 w-full space-y-2">
                        <p className="text-slate-400 text-xs">Importe reservado: <span className="text-white font-semibold">{fmtEur(request.amount)}</span></p>
                        <p className="text-white font-mono text-[12.5px] break-all" data-testid={`investment-wallet-address-${request.id}`}>{w.address}</p>
                        <Button size="sm" onClick={copy} className="bg-amber-500 hover:bg-amber-400 text-slate-950 font-bold h-8" data-testid={`investment-wallet-copy-${request.id}`}>
                            {copied ? <Check className="w-3.5 h-3.5 mr-1.5" /> : <Copy className="w-3.5 h-3.5 mr-1.5" />}{copied ? 'Copiada' : 'Copiar dirección'}
                        </Button>
                        <p className="text-[11px] text-amber-300/90 flex items-start gap-1.5">
                            <AlertTriangle className="w-3.5 h-3.5 mt-0.5 flex-shrink-0" />
                            Envía únicamente {w.name} por la red {w.network}{w.required_confirmations ? ` · ${w.required_confirmations} confirmaciones` : ''}. Otros activos o redes podrían perderse.
                        </p>
                    </div>
                </div>
            )}
            <div className="px-3.5 pb-4"><ConfirmPaymentForm request={request} onDone={onChanged} /></div>
        </div>
    );
};
